import { render } from "./DocsPage.vue?vue&type=template&id=123cd7f8"
import script from "./DocsPage.vue?vue&type=script&lang=js"
export * from "./DocsPage.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./DocsPage.vue?vue&type=style&index=0&id=123cd7f8&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script